var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("file-pond", {
    ref: "pond",
    attrs: {
      "class-name": "file-pond-font-size-increase margin-above2x",
      "label-file-processing-error": "File error",
      "label-idle": _vm.labelIdle,
      disabled: _vm.disabled,
      "accepted-file-types": _vm.acceptedFileTypes,
      "file-validate-type-label-expected-types-map":
        _vm.fileValidateTypeLabelExpectedTypesMap,
      server: {
        process: (fieldName, file, metadata, load, error) =>
          _vm.postFile(file, load, error, true),
        revert: null,
        fetch: null,
      },
    },
    on: {
      processfileprogress: (file, progress) => _vm.changeProgress(progress),
      removefile: _vm.setInitialState,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }